import React, { useState } from 'react';
import './BrandAmbassadors.css';
import Sponsorships from '../../components/SponsorshipSection/SponsorshipSection';
import BottomNav from '../../components/BottomNav/BottomNav';
import Header from '../../components/Header/Header';
import { useNavigate } from "react-router-dom";
  const BrandAmbassadors = () => {
  const navigate = useNavigate();
  const [currentQuote, setCurrentQuote] = useState(0);

  const quotes = [
    '"TAKE YOUR VICTORIES, WHATEVER THEY MIGHT BE, CHERISH THEM, USE THEM, BUT DON\'T SETTLE FOR THEM."',
    '"SUCCESS IS NOT FINAL, FAILURE IS NOT FATAL: IT IS THE COURAGE TO CONTINUE THAT COUNTS."'
  ];

  const handlePrevQuote = () => {
    setCurrentQuote((prev) => prev === 0 ? quotes.length - 1 : prev - 1);
  };

  const handleNextQuote = () => {
    setCurrentQuote((prev) => prev === quotes.length - 1 ? 0 : prev + 1);
  };

  return (
    <>
      <Header />
    <div className="brand-ambassadors-container">
      {/* Header with Background Image */}
      <div className="brand-ambassadors-header">
        <img 
          src="/images/Sectionpaints.png" 
          alt="Mia Khalifa"
          className="brand-ambassadors-header-bg"
        />
        <div className="brand-ambassadors-header-content">
          <button onClick={() => navigate(-1)} className="brand-ambassadors-back">
            <span className="brand-ambassadors-back-icon">‹</span>
            Brand Ambassadors
          </button>
          <div className="brand-ambassadors-header-info">
            <h1 className="brand-ambassadors-name">mia Khalifa</h1>
            <p className="brand-ambassadors-subtitle">Mia Khalifa as Baji Ambassador 2024</p>
          </div>
        </div>
      </div>

      {/* Quote Section */}
      <div className="brand-ambassadors-quote-section">
        <div className="brand-ambassadors-quote">
          <button 
            className="brand-ambassadors-nav brand-ambassadors-nav-left"
            onClick={handlePrevQuote}
          >
            ‹
          </button>
          <p className="brand-ambassadors-quote-text">
            {quotes[currentQuote]}
          </p>
          <button 
            className="brand-ambassadors-nav brand-ambassadors-nav-right"
            onClick={handleNextQuote}
          >
            ›
          </button>
        </div>

        {/* Biography within quote section */}
        <div className="brand-ambassadors-bio">
          <p className="brand-ambassadors-bio-text">
            Mia Khalifa, originally from Lebanon, embarked on a transformative journey when her family relocated to the United States in 2001. Growing up in Beirut, she attended a private French-language school, mastering both her native language and English.
          </p>
          <p className="brand-ambassadors-bio-text">
            Her life journey led her to Montgomery County, Maryland, during her teens, where she attended Northwest High School. Further, furthering her education, Khalifa earned a Bachelor of Arts in History from the University of Texas at El Paso. This diverse background laid the foundation for her multifaceted journey, embodying her experiences and cultural influences.
          </p>
          <p className="brand-ambassadors-bio-text">
            Life took an unexpected turn as she became a notable figure in the adult film industry, quickly gaining recognition beyond its confines. Post-industry, Khalifa seamlessly transitioned into roles as a paralegal and bookkeeper in Miami while cultivating a massive social media following.
          </p>
          <p className="brand-ambassadors-bio-text">
            Her magnetic charm and engaging personality positioned her as a prominent social media personality and webcam model, showcasing her versatility. Additionally, Khalifa ventured into the realm of sports commentary, adding yet another dimension to her dynamic persona. Throughout her journey, Khalifa exudes a captivating charm, effortlessly navigating challenges with a touch of glamour. Life, for her, isn't about toughness before ease; it's about embracing the allure of transformation. This philosophy infuses her endeavours with an extra layer of charm and positivity, making every moment in her world an irresistible experience.
          </p>
        </div>
      </div>

      {/* Career Highlights */}
      <div className="brand-ambassadors-career">
        <h2 className="brand-ambassadors-career-title">CAREER HIGHLIGHTS</h2>
        
        <div className="brand-ambassadors-career-grid">
          {/* Row 1 */}
          <div className="brand-ambassadors-career-row">
            <div className="brand-ambassadors-career-item">
              <h3 className="brand-ambassadors-career-item-title">Breakthrough</h3>
              <p className="brand-ambassadors-career-item-desc">
                In 2014, Khalifa entered the sex industry, swiftly rising to become the most-viewed performer on a major adult website within a year of her debut.
              </p>
            </div>
            
            <div className="brand-ambassadors-career-divider"></div>
            
            <div className="brand-ambassadors-career-item">
              <h3 className="brand-ambassadors-career-item-title">Major Deal</h3>
              <p className="brand-ambassadors-career-item-desc">
                By 2015, Khalifa secured a long-term contract with WGCZ Holding, the parent company of Bang Bros, which owned the largest free porn site, XVideos
              </p>
            </div>
          </div>

          {/* Row 2 */}
          <div className="brand-ambassadors-career-row">
            <div className="brand-ambassadors-career-item">
              <h3 className="brand-ambassadors-career-item-title">Career Transition</h3>
              <p className="brand-ambassadors-career-item-desc">
                Pivoting away from adult films, Khalifa shifted her career to work as a paralegal and bookkeeper in Miami after a three-month stint as an adult film actor.
              </p>
            </div>
            
            <div className="brand-ambassadors-career-divider"></div>
            
            <div className="brand-ambassadors-career-item">
              <h3 className="brand-ambassadors-career-item-title">Diversification</h3>
              <p className="brand-ambassadors-career-item-desc">
                Following retirement, Khalifa diversified her career, expanding into roles as a social media personality, webcam model, and sports commentator.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Awards & Achievements */}
      <div className="brand-ambassadors-awards">
        <div className="brand-ambassadors-awards-card">
          <h2 className="brand-ambassadors-awards-title">AWARDS & ACHIEVEMENTS</h2>
          
          <div className="brand-ambassadors-timeline">
            <div className="brand-ambassadors-award-year">
              <div className="brand-ambassadors-award-year-label">2015</div>
              <div className="brand-ambassadors-award-content">
                <p className="brand-ambassadors-award-text">
                  KHALIFA EMERGED AS ONE OF THE MOST SEARCHED NAMES ON THE INTERNET.
                </p>
              </div>
            </div>

            <div className="brand-ambassadors-award-year">
              <div className="brand-ambassadors-award-year-label">2016</div>
              <div className="brand-ambassadors-award-content">
                <p className="brand-ambassadors-award-text">
                  KHALIFA EXPANDED HER PRESENCE WITH A YOUTUBE CHANNEL, LIVE STREAMED ON TWITCH, AND OFFERED PHOTOS, MERCHANDISE, AND OTHER EXCLUSIVE CONTENT ON PATREON.
                </p>
              </div>
            </div>

            <div className="brand-ambassadors-award-year">
              <div className="brand-ambassadors-award-year-label">2017</div>
              <div className="brand-ambassadors-award-content">
                <p className="brand-ambassadors-award-text">
                  KHALIFA CO-HOSTED COMPLEX'S "OUT OF BOUNDS" WEB SERIES.
                </p>
                <p className="brand-ambassadors-award-text">
                  KHALIFA CONTINUED TO BE ONE OF THE MOST SEARCHED-FOR ADULT ACTRESSES.
                </p>
              </div>
            </div>

            <div className="brand-ambassadors-award-year">
              <div className="brand-ambassadors-award-year-label">2018</div>
              <div className="brand-ambassadors-award-content">
                <p className="brand-ambassadors-award-text">
                  KHALIFA SERVED AS A CO-HOST ALONGSIDE TYLER COE ON ROOSTER TEETH'S SPORTSBALL.
                </p>
                <p className="brand-ambassadors-award-text">
                  KHALIFA ATTAINED THE COVETED NO. 1 RANKING AS A PERFORMER ON A MAJOR ADULT WEBSITE.
                </p>
              </div>
            </div>

            <div className="brand-ambassadors-award-year">
              <div className="brand-ambassadors-award-year-label">2023</div>
              <div className="brand-ambassadors-award-content">
                <p className="brand-ambassadors-award-text">
                  KHALIFA LAUNCHED "SHEYTAN", A JEWELLERY LINE, IN COLLABORATION WITH SARA BURN.
                </p>
                <p className="brand-ambassadors-award-text">
                  REPORTEDLY, MIA KHALIFA'S NET WORTH IS ESTIMATED TO BE NEARLY $8 MILLION.
                </p>
              </div>
            </div>
          </div>

        </div>
          <div className="brand-ambassadors-awards-footer">
            <img 
              src="/images/miabg.png" 
              alt="Mia Khalifa"
              className="brand-ambassadors-awards-image"
            />
            {/* <div className="brand-ambassadors-signature">
              <span className="brand-ambassadors-signature-text">Mia k</span>
              <span className="brand-ambassadors-signature-name">MIA KHALIFA</span>
            </div> */}
          </div>
      </div>

          <h3 className="brand-ambassadors-gallery-title">GALLERY</h3>
      {/* Gallery Footer */}
      <div className="brand-ambassadors-gallery-section">
       
        
        
        {/* Image Slider */}
        <div className="brand-ambassadors-gallery-slider">
          <div className="brand-ambassadors-gallery-track">
            <div className="brand-ambassadors-gallery-item">
              <img src="/images/imageMia.png" alt="Gallery 1" />
            </div>
            <div className="brand-ambassadors-gallery-item center">
              <img src="/images/imageMia1.png" alt="Gallery 2" />
            </div>
            <div className="brand-ambassadors-gallery-item">
              <img src="/images/imageMia.png" alt="Gallery 3" />
            </div>
            <div className="brand-ambassadors-gallery-item">
              <img src="/images/imageMia.png" alt="Gallery 1" />
            </div>
            <div className="brand-ambassadors-gallery-item center">
              <img src="/images/imageMia1.png" alt="Gallery 2" />
            </div>
            <div className="brand-ambassadors-gallery-item">
              <img src="/images/imageMia.png" alt="Gallery 3" />
            </div>
          </div>
        </div>
      </div>

      {/* Video Section */}
      <div className="brand-ambassadors-video-section">
        <div className="brand-ambassadors-video-header">
          <h3 className="brand-ambassadors-video-title">FOR ALL OF YOU</h3>
          <h4 className="brand-ambassadors-video-subtitle">THE BEST OF BAJI</h4>
        </div>

        <div className="brand-ambassadors-video-container">
          <img 
            src="/images/imageMia1.png" 
            alt="Video"
            className="brand-ambassadors-video-thumbnail"
          />
          <button className="brand-ambassadors-video-play">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
              <circle cx="40" cy="40" r="40" fill="white" fillOpacity="0.9"/>
              <path d="M32 25L55 40L32 55V25Z" fill="#000"/>
            </svg>
          </button>
        </div>
      </div>
      <Sponsorships />
      <BottomNav />
    </div>
    </>
  );
};

export default BrandAmbassadors;